<template>
  <div class="side-page" v-if="visible">
    <div class="side-page-content">
      <h2>Edit Asset</h2>

      <div class="form-group">
        <label for="deviceName">Device Name:</label>
        <input id="deviceName" v-model="deviceName" placeholder="Enter device name" />
      </div>

      <div class="form-group">
        <label for="deviceType">Device Type:</label>
        <input id="deviceType" v-model="deviceType" placeholder="Enter device type" />
      </div>

      <div class="form-group">
        <label for="building">Building:</label>
        <input id="building" v-model="building" placeholder="Enter building" />
      </div>

      <div class="form-group">
        <label for="floor">Floor:</label>
        <input id="floor" v-model="floor" placeholder="Enter floor" />
      </div>

      <div class="form-group">
        <label for="selectIcon">Select Icon:</label>
        <div class="icon-select-container">
          <select id="selectIcon" v-model="selectedIcon" @change="handleIconChange">
            <option value="">Select Icon</option>
            <option v-for="(icon, index) in icons" :value="icon.value" :key="index">
              {{ icon.name }}
            </option>
          </select>
          <div class="icon-preview" v-if="selectedIcon">
            <span class="material-symbols-outlined">{{ selectedIcon }}</span>
          </div>
        </div>
      </div>

      <div class="button-group">
        <button @click="save">Save</button>
        <button @click="close">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    asset: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      deviceName: this.asset.devicename || '',
      deviceType: this.asset.devicetype || '',
      building: this.asset.building || '',
      floor: this.asset.floor || '',
      imageFile: null,
      selectedIcon: this.asset.icon || '',
      icons: [
        { name: 'Monitor', value: 'monitor' },
        { name: 'Computer', value: 'computer' },
        { name: 'Printer', value: 'print' },
        { name: 'Power Supply', value: 'electric_bolt' },
        { name: 'Oscilloscope', value: 'analytics' },
        { name: 'Function Generator', value: 'speed' },
        { name: 'PCB', value: 'memory' },
        { name: 'Probe', value: 'cable' },
        { name: 'Digital Multi Meter', value: 'electric_meter' },
        { name: 'Load Generator', value: 'power' },
        { name: 'Machine', value: 'precision_manufacturing' },
        { name: 'Robot', value: 'smart_toy' },
        { name: 'Factory Machine', value: 'factory' },
        { name: 'Tools', value: 'build' },
        { name: 'Settings', value: 'settings' },
        { name: 'Construction', value: 'construction' },
        { name: 'Engineering', value: 'engineering' },
        { name: 'Hardware', value: 'hardware' }
      ]
    };
  },
  methods: {
    handleImageUpload(event) {
      this.imageFile = event.target.files[0]; // 선택된 이미지 파일
    },
    handleIconChange() {
      // 아이콘 변경 시 필요한 로직
      this.$emit('icon-change', this.selectedIcon);
    },
    save() {
      const formData = new FormData();
      formData.append('tag_mac', this.asset.tag_mac);
      formData.append('devicename', this.deviceName || '');
      formData.append('devicetype', this.deviceType || '');
      formData.append('building', this.building || '');
      formData.append('floor', this.floor || '');
      formData.append('icon', this.selectedIcon || '');

      if (this.imageFile) {
        formData.append('image', this.imageFile);
      }

      // FormData 내용 확인을 위한 디버깅
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }

      this.$emit('save', formData);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.side-page {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background-color: white;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
  padding: 20px;
  z-index: 1000;
  overflow-y: auto;
  font-family: Arial, sans-serif;
  border-radius: 12px 0 0 12px;
  transition: transform 0.3s ease;
}

h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

input, select {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
}

input:focus, select:focus {
  outline: none;
  border-color: #4e73df;
  box-shadow: 0 4px 12px rgba(78, 115, 223, 0.15);
}

.icon-select-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
}

.icon-preview .material-symbols-outlined {
  font-size: 24px;
  color: #666;
}

.button-group {
  margin-top: 30px;
  display: flex;
  gap: 12px;
}

button {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:first-child {
  background-color: #4e73df;
  color: white;
}

button:first-child:hover {
  background-color: #3a5bc7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(78, 115, 223, 0.3);
}

button:last-child {
  background-color: #6c757d;
  color: white;
}

button:last-child:hover {
  background-color: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

/* 반응형 디자인 - 태블릿 (1200px 이하) */
@media screen and (max-width: 1200px) {
  .side-page {
    width: 350px;
    padding: 16px;
  }
  
  h2 {
    font-size: 22px;
    margin-bottom: 16px;
  }
  
  .form-group {
    margin-bottom: 16px;
  }
  
  label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  input, select {
    padding: 10px;
    font-size: 13px;
  }
  
  .icon-preview {
    width: 36px;
    height: 36px;
  }
  
  .icon-preview .material-symbols-outlined {
    font-size: 20px;
  }
  
  button {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* 반응형 디자인 - 모바일 (768px 이하) */
@media screen and (max-width: 768px) {
  .side-page {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    padding: 16px;
    right: 0;
    top: 0;
    box-shadow: none;
    background-color: #f8f9fa;
  }
  
  h2 {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: center;
    background: white;
    margin: -16px -16px 20px -16px;
    padding: 16px;
    border-radius: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    background: white;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  label {
    font-size: 13px;
    margin-bottom: 8px;
    color: #555;
  }
  
  input, select {
    padding: 12px;
    font-size: 14px;
    border: 1px solid #ddd;
  }
  
  .icon-select-container {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .icon-preview {
    width: 100%;
    height: 50px;
    align-self: center;
    max-width: 200px;
  }
  
  .button-group {
    margin-top: 20px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    padding: 16px 0;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
    border-top: 1px solid #e0e0e0;
  }
  
  button {
    padding: 14px 20px;
    font-size: 14px;
    font-weight: 600;
  }
}

/* 반응형 디자인 - 작은 모바일 (480px 이하) */
@media screen and (max-width: 480px) {
  .side-page {
    padding: 12px;
  }
  
  h2 {
    font-size: 18px;
    margin: -12px -12px 16px -12px;
    padding: 12px;
  }
  
  .form-group {
    padding: 12px;
    margin-bottom: 10px;
  }
  
  label {
    font-size: 12px;
    margin-bottom: 6px;
  }
  
  input, select {
    padding: 10px;
    font-size: 13px;
  }
  
  .icon-preview {
    height: 40px;
  }
  
  .icon-preview .material-symbols-outlined {
    font-size: 18px;
  }
  
  .button-group {
    margin-top: 16px;
    gap: 8px;
    margin-left: -12px;
    margin-right: -12px;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  
  button {
    padding: 12px 16px;
    font-size: 13px;
  }
}

/* 큰 화면에서의 최적화 (1600px 이상) */
@media screen and (min-width: 1600px) {
  .side-page {
    width: 450px;
    padding: 24px;
  }
  
  h2 {
    font-size: 26px;
    margin-bottom: 24px;
  }
  
  .form-group {
    margin-bottom: 24px;
  }
  
  label {
    font-size: 15px;
    margin-bottom: 10px;
  }
  
  input, select {
    padding: 14px 16px;
    font-size: 15px;
  }
  
  .icon-preview {
    width: 50px;
    height: 50px;
  }
  
  .icon-preview .material-symbols-outlined {
    font-size: 28px;
  }
  
  .button-group {
    margin-top: 36px;
    gap: 16px;
  }
  
  button {
    padding: 14px 24px;
    font-size: 15px;
  }
}

/* 랜드스케이프 모드 최적화 */
@media screen and (max-width: 768px) and (orientation: landscape) {
  .side-page {
    padding: 12px;
  }
  
  h2 {
    font-size: 18px;
    margin: -12px -12px 16px -12px;
    padding: 12px;
  }
  
  .form-group {
    margin-bottom: 8px;
    padding: 12px;
  }
  
  label {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  input, select {
    padding: 8px;
    font-size: 13px;
  }
  
  .icon-select-container {
    flex-direction: row;
    gap: 8px;
  }
  
  .icon-preview {
    width: 35px;
    height: 35px;
  }
  
  .button-group {
    margin-top: 16px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid #e0e0e0;
    padding: 12px;
    gap: 12px;
  }
  
  button {
    padding: 10px 16px;
    font-size: 13px;
  }
}

/* 접근성 개선 */
@media (prefers-reduced-motion: reduce) {
  .side-page,
  button,
  input,
  select {
    transition: none;
  }
  
  button:hover {
    transform: none;
  }
}

/* 다크모드 대응 */
@media (prefers-color-scheme: dark) {
  .side-page {
    background-color: #2d2d2d;
    color: #ffffff;
  }
  
  h2 {
    color: #ffffff;
    border-bottom-color: #404040;
  }
  
  label {
    color: #cccccc;
  }
  
  input, select {
    background-color: #404040;
    border-color: #555555;
    color: #ffffff;
  }
  
  input:focus, select:focus {
    border-color: #6c8cdf;
    box-shadow: 0 4px 12px rgba(108, 140, 223, 0.15);
  }
  
  .form-group {
    background: #333333;
  }
  
  .icon-preview {
    background: #404040;
    border-color: #555555;
  }
  
  .icon-preview .material-symbols-outlined {
    color: #cccccc;
  }
  
  .button-group {
    background: #2d2d2d;
    border-top-color: #404040;
  }
}
</style>
